import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { getCurrentDateTime } from '../../../../../utils';

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  doctorHeading: {
    fontSize: 14,
    fontWeight: 'bold',
    marginVertical: 10
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 5,
    textAlign: 'center'
  },
  columnNumerContent: {
    width: '15%',
    padding: 5,
    textAlign: 'right'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const groupByDoctor = (data) => {
  return data.reduce((acc, item) => {
    const doctorName = item.name;
    if (!acc[doctorName]) {
      acc[doctorName] = {
        patients: [],
        totalNetAmount: 0
      };
    }
    acc[doctorName].patients.push(item);
    acc[doctorName].totalNetAmount += item.opd.total;
    return acc;
  }, {});
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const ConsultantWiseOpdReportPdf = ({ data }) => {
  console.log('hello Consultant', data);
  const groupedData = groupByDoctor(data);
  
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }


  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Consultant Wise Opd Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            {Object.keys(groupedData).map((doctorName) => (
              <View key={doctorName}>
                <Text style={styles.doctorHeading} content={` ${doctorName}`} />
                <Text
                  style={{ fontSize: '8px' }}
                  content={`Total Net Amount: ${groupedData[doctorName].totalNetAmount}`}
                />
                <View style={styles.row}>
                  <Text style={{...styles.columnHeader, width:'9%'}} content="Sr No." />
                  <Text style={styles.columnHeader} content="Date" />
                  <Text style={styles.columnHeader} content="OPD No." />
                  <Text style={styles.columnHeader} content="Patient Name" />
                  <Text style={styles.columnHeader} content="Age" />
                  <Text style={styles.columnHeader} content="Category" />
                  <Text style={styles.columnHeader} content="Due" />
                  <Text style={styles.columnHeader} content="Dis" />
                  <Text style={{...styles.columnHeader, width:'11%'}} content="Net Amount" />
                </View>
                {groupedData[doctorName].patients.map((item, index) => (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                    <Text style={styles.columnContent} content={formatDate(item.opd.date)} />
                    <Text style={styles.columnContent} content={item.opd.op_no} />
                    <Text style={{ ...styles.columnContent, width: '18%', textAlign: 'left' }}
                      content={`${item.opd.name_suffix} ${item.opd.first_name} ${item.opd.last_name}`}
                    />
                    <Text style={{ ...styles.columnContent, width: '6%' }}
                      content={new Date().getFullYear() - new Date(item.opd.dob).getFullYear()} />
                    <Text style={{...styles.columnNumerContent}} content={item.opd.sponsor?.name} />
                    <Text style={styles.columnNumerContent} content={item.opd.reg} />
                    <Text style={styles.columnNumerContent} content={item.opd.disc} />
                    <Text style={{...styles.columnNumerContent, marginRight: '20px'}} content={item.opd.total} />
                  </View>
                ))}
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default ConsultantWiseOpdReportPdf;
